import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { paymentStatementsConfig } from '../shared/data/paymentStatments.config';
import { PaymentStatementsService } from '../shared/payment-statements.service';
import {environment} from "../../environments/environment";

interface StatementForm {
  [index: string]: FormGroup;
}

interface Loading {
  [index: string]: boolean;
}

@Component({
  selector: 'app-payment-statements',
  templateUrl: './payment-statements.component.html',
  styleUrls: ['./payment-statements.component.css'],
})
export class PaymentStatementsComponent implements OnInit {
  dropDownItems: any = {};
  paymentStatementConfig = paymentStatementsConfig;
  statementsForm: StatementForm = {};
  labId: string;
  loading: Loading = {};
  loadingBtn: Loading = {};
  labLogUrl: string = environment.labLogonUrl;

  constructor(
    private paymentStatementsService: PaymentStatementsService,
    private fb: FormBuilder
  ) {
    this.labId = this.paymentStatementsService.labId;
    if (this.labId) {
      this.createForms();
    }
  }

  ngOnInit() {
    if (this.labId) {
      this.getDropdownItems();
    }
  }

  createForms() {
    this.paymentStatementConfig.itemBlocks.forEach((item) => {
      if (item.formFields) {
        this.statementsForm[item.name] = this.fb.group(
          item.formFields.reduce((acc, field) => {
            acc[field.name] = '';
            return acc;
          }, {})
        );
      }
    });
  }

  getDropdownItems() {
    this.paymentStatementConfig.itemBlocks.forEach((item) => {
      item.formFields.forEach((field) => {
        this.loading[field.name] = true;
        if (field.type === 'dropdown') {
          this.paymentStatementsService
            .getPaymentStatementsMetadata(field.name)
            .subscribe({
              next: (statementMetadata) => {
                this.loading[field.name] = false;
                this.dropDownItems[field.name] = statementMetadata;
                if (statementMetadata.length) {
                  this.statementsForm[item.name].setValue({
                    [field.name]: statementMetadata[0].documentUuid,
                  });
                }
              },
              error: (error) => {
                this.loading[field.name] = false;
                this.dropDownItems[field.name] = [];
                console.log(error);
              },
            });
        }
      });
    });
  }

  viewStatement(formName: string) {
    this.loadingBtn[formName] = true;
    let selectedDocArray = this.dropDownItems[formName];
    let selectedDoc = selectedDocArray.find(
      (doc) => doc.documentUuid === this.statementsForm[formName].value[formName]
    );

    if (!selectedDoc || !selectedDoc.link) {
      alert('Document not found!');
      return;
    }

    let selectedDocUrl = selectedDoc.link.href;
    this.paymentStatementsService
      .getStatementPreSignedUrl(selectedDocUrl)
      .subscribe({
        next: (docUrl) => {
          this.loadingBtn[formName] = false;

          if (docUrl && docUrl.href) {
            window.open(docUrl.href);
          } else {
            alert('There was an error processing your request!');
          }
        },
        error: (error: HttpErrorResponse) => {
          this.loadingBtn[formName] = false;
          alert(error.error.message || 'Unable to retrieve the requested document');
        },
      });
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/payment-statements/payment-statements.component.ts